import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { setUnreadSummary } from './lib/documentTitle';
import { registerServiceWorker, resyncPush, setAppBadge } from './lib/pwa';
import { useAppStore } from './store/app';
import { totalUnread } from './store/selectors';
import { useAuthStore } from './store/auth';
import './styles/theme.css';
import './styles/base.css';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

void registerServiceWorker();
// Ungelesene In-App-Benachrichtigungen als App-Badge (installierte PWA).
useAppStore.subscribe((s, prev) => {
  if (s.unreadNotifications !== prev.unreadNotifications) setAppBadge(s.unreadNotifications);
});
// Ungelesen-Stand im Fenstertitel („(3) Lagerfeuer“ / „• Lagerfeuer“) – liest auch Lagerfeuer Desktop (D35).
useAppStore.subscribe((s) => setUnreadSummary(totalUnread(s)));
// Nach dem Anmelden ein vorhandenes Push-Abo beim Server auffrischen (ohne Berechtigungsabfrage).
useAuthStore.subscribe((s, prev) => {
  if (s.accessToken && !prev.accessToken) void resyncPush().catch(() => false);
});
